/**
 * Patient Requirements feature auto-registration and exports (GDN-3224).
 *
 * Every surface sits behind the `patient_requirements` Statsig gate
 * (FeatureGates.PATIENT_REQUIREMENTS) — the gate is checked by the host, not
 * in here, so callers can combine it with their own permission rules.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { patientRequirementsFeature } from './store/feature';

autoRegisterFeature(patientRequirementsFeature);

export * from './components';
export * from './constants';
export { MissingRequirementListPage } from './MissingRequirementListPage';
export * from './store';
export * from './types';
export * from './vocabulary';
